import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import event from "../lib/mixins/event";

gsap.registerPlugin(ScrollTrigger);

class PhotoMoment {
	constructor(dom) {
		this.NAME = "PhotoMoment";
		this.dom = dom;
	}

	init() {
		const section = this.dom;
		const bgImage = section.querySelector('.photo-moment__bg-image');
		const floatEl = section.querySelector('.photo-moment__float');

		const triggerOpts = {
			trigger: section,
			start: 'top bottom',
			end: 'bottom top',
			scrub: 1,
		};

		if (bgImage) {
			gsap.fromTo(bgImage,
				{ y: -60 },
				{ y: 60, ease: 'none', scrollTrigger: triggerOpts }
			);
		}

		if (floatEl) {
			gsap.fromTo(floatEl,
				{ y: -30 },
				{ y: 30, ease: 'none', scrollTrigger: triggerOpts }
			);
		}
	}
}

Object.assign(PhotoMoment.prototype, event);
export default PhotoMoment;
